<template>
    <div class="layout-main-container">
        <div class="layout-main" dir="rtl">
            <OperationGrid :operations="operations" :pageSize="pageSize" :totalOperationsCount="totalOperationsCount"
                @filterTriggered="filterOperations"
                @pageRequested="pageRequest => loadPage(pageRequest.number, pageRequest.filter)"
                @messagesReadMark="handleMessagesReadMark" />
        </div>
    </div>
</template>

<script setup>
import { onBeforeUnmount, onErrorCaptured, onMounted, ref } from 'vue'
import { handleError } from '@/helpers/ErrorHandler'
import { useToast } from "primevue/usetoast"
import { useAuthStore } from '@/stores/auth'
import { useI18n } from 'vue-i18n'
import OperationGrid from '@/components/OperationGrid.vue'
import operationService from '@/service/OperationService'
import { socketMessageTypeEnum } from '@/helpers/Constants'
import SocketListener from '@/model/SocketListener'
import socketService from '@/service/SocketService'
import { useGlobalStore } from '@/stores/global'
import OperationFilter from '@/model/OperationFilter'
import { operationStatusEnum } from '@/helpers/Constants'

const authStore = useAuthStore()
const globalStore = useGlobalStore()
const toast = useToast()
const i18n = useI18n()

const pageSize = 20
const totalOperationsCount = ref(0)
const operations = ref([])

let uniqueId

onMounted(async () => {
    uniqueId = 'OPERATIONS_' + new Date().getTime()
    socketService.addListener(socketMessageTypeEnum.OPERATION_UPDATE, new SocketListener(uniqueId, handleOperationStatusChange))
    socketService.addListener(socketMessageTypeEnum.CHAT_MESSAGE, new SocketListener(uniqueId, handleInstantMessage))
    try {
        if (globalStore.sharedData !== null) {
            const operationId = globalStore.sharedData
            globalStore.sharedData = null
            await filterOperations(new OperationFilter(null, null, null, null, null, operationId))
        } else {
            await loadPage(0)
        }
    } catch (error) {
        handleError(authStore, toast, i18n, error)
    }
})

onErrorCaptured((err, instance, info) => {
    return handleError(authStore, toast, i18n, err, instance, info)
})

onBeforeUnmount(() => {
    socketService.removeListener(uniqueId)
})

const loadPage = async (number, filter) => {
    const response = await operationService.findOperations(number, pageSize, filter)
    operations.value = response.collection
    totalOperationsCount.value = response.total
}

const filterOperations = async (filter) => {
    await loadPage(0, filter)
}

const handleOperationStatusChange = (message) => {
    const operation = operations.value.filter(o => o.id === message.operationId)
    if (operation.length > 0) {
        if (message.newStatusId !== undefined && message.newStatusId !== null) {
            operation[0].statusId = message.newStatusId
            if (message.newStatusId === operationStatusEnum.COMPLETED) {
                operation[0].daysToExpire = null
            }
        }
    }
}

const handleInstantMessage = (message) => {
    const operation = operations.value.filter(o => o.id === message.operationId)
    if (operation.length > 0) {
        operation[0].unreadMessages = true
    }
}

const handleMessagesReadMark = (operationId) => {
    operations.value.filter(o => o.id === operationId).forEach(o => o.unreadMessages = false)
}

</script>

<style scoped></style>
